import React from 'react'
import Ultrasonic from './Ultrasonic'
// import { IconAlternate } from 'components/molecules';


export const services = [
    {
      icon: 'fas fa-layer-group',
      title: 'Capabilities',
      subtitle:
        'Fully automated workflow , Powered by AFA-energetics ® ,Multiple isothermal energy delivery modes' ,
    },
    {
      icon: 'fas fa-dollar-sign',
      title: 'Benefits ' ,
      subtitle:
        'Accurate, reproducible, and robust sample preparation ,Tunable, non-contact processing , Simplify highly complex workflows ',
    },

  ];

function Ultrasonicpart() {
    return (
        <div>
           <Ultrasonic data = {services}/> 
        </div>
    )
}

export default Ultrasonicpart
